import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/scouting-analysis/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/scouting-analysis/';

class ScoutingAnalysisService {

  createPlayerScoutingAnalysis(analysis) {
    return axios.post(`${API_URL}player`, analysis);
  };

  getPlayerScoutingAnalysis() {
    return axios.get(`${API_URL}players`);
  };

  getPlayerScoutingAnalysisByPlayerId(playerId) {
    return axios.get(`${API_URL}player/${playerId}`, playerId);
  };

  deletePlayerScoutingAnalysis(analysisId) {
    return axios.delete(`${API_URL}player/${analysisId}`, analysisId);
  };

  getPlayerFinalRatingAvg(playerId) {
    return axios.get(`${API_URL}player/${playerId}/avg-final-rating`);
  };

  getPlayerOverallScoreAvg(playerId) {
    return axios.get(`${API_URL}player/${playerId}/avg-overall-score`);
  };

  updatePlayerScoutingAnalysis(analysis) {
    return axios.put(`${API_URL}player`, analysis);
  };

  getPlayerScoutingAnalysisByTaskIds(taskIds) {
    return axios.get(`${API_URL}player/from-task/${taskIds}`, taskIds);
  };
}

export default new ScoutingAnalysisService();



// WEBPACK FOOTER //
// ./src/services/scoutingAnalysis.service.js